import { coreApi } from '../../../../api'

async function fetchApproveCredit(id: string) {
  const { data: response } = await coreApi.get(
    `/analysis/auto-refi/data/credit-references/${id}/approve-credit`,
  )

  return {
    maxLoanAmountApproved: response.data.attributes.maxLoanAmountApproved,
    contractLoanAmount: response.data.attributes.contractLoanAmount,
  }
}

export { fetchApproveCredit }
